import React, { useCallback } from 'react'
import { useFetchAllMarketingLabels } from '@@partner:graphql/query/labels/allMarketingLabels.gql'
import { useGridHelper } from '@@partner:helpers/crud/grid'
import { generatePath } from 'react-router'

import LabelsTable from './grid/LabelsTable'
import Pagination from 'rsuite/esm/Pagination/Pagination'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'

import { ROUTE_MARKETING_LABEL_EDIT } from '@@partner:config/routes'

export interface LabelGridProps {
  brandSlug: string
}

export default function LabelsGrid ({ brandSlug }: LabelGridProps) {
  const { page, tableSort, handlePageSelect, handleSortColumn } =
    useGridHelper()

  const { data, loading, error } = useFetchAllMarketingLabels({
    pager: { page },
    sort: {
      fieldName: tableSort.fieldName,
      direction: tableSort.direction
    }
  })

  const generateEditUrl = useCallback(
    (labelId) => {
      return generatePath(ROUTE_MARKETING_LABEL_EDIT, {
        brandSlug,
        labelId
      })
    },
    [ brandSlug ]
  )

  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        title="Ошибка загрузки промокодов"
        error={error}
      />
    )
  }

  return (
    <div>
      <LabelsTable
        items={data?.allMarketingLabels?.edges ?? []}
        tableSort={tableSort}
        loading={loading}
        onSortColumn={handleSortColumn}
        generateEditUrl={generateEditUrl}
      />

      <Pagination
        last
        first
        next
        prev
        ellipsis
        activePage={page}
        pages={data?.allMarketingLabels?.pageInfo?.lastPage}
        maxButtons={10}
        onSelect={handlePageSelect}
      />
    </div>
  )
}
